<template>
  <div>
    <md-content class="md-elevation-3">
      <md-field>
        <label for="city">City</label>
        <md-select v-model="city" name="city" id="city">
          <md-option value="956-275-2687">Dev (956-275-2687)</md-option>
          <md-option value="512-580-7299">Austin (512-580-7299)</md-option>
          <md-option value="312-626-5096">Chicago (312-626-5096)</md-option>
          <md-option value="new york" disabled>New York</md-option>
        </md-select>
      </md-field>

      <md-field>
        <label>Phone Numbers</label>
        <md-textarea v-model="number" md-autogrow></md-textarea>
      </md-field>
      <p>*Input numbers on separate lines.</p>
      
      <md-field>
        <label for="message">Prewritten Message</label>
        <md-select @md-selected="textMessage = prewrittenMessage.chosenMessage" v-model="prewrittenMessage.chosenMessage" 
          name="message" id="message">
          <md-option :value="prewrittenMessage.custom">Custom</md-option>
          <md-option :value="prewrittenMessage.atxInv">Austin Invite</md-option>
          <md-option :value="prewrittenMessage.atxRem">Austin Reminder</md-option>
          <md-option :value="prewrittenMessage.chiInv">Chicago Invite</md-option>
          <md-option :value="prewrittenMessage.chiRem">Chicago Reminder</md-option>
        </md-select>
      </md-field>

      <md-field>
        <label>Text Message</label>
        <md-textarea v-model="textMessage"></md-textarea>
      </md-field>

      <span>
        <!-- <md-button class="md-raised" @click="showNumbers = !showNumbers">Toggle Numbers</md-button> -->
        <md-button class="md-raised" @click="validMessage" v-if="!server.sendingMessages">Send</md-button>
        <md-button class="md-raised" v-else>
          <md-progress-spinner :md-diameter="20" :md-stroke="3" md-mode="indeterminate"/>
        </md-button>
      </span>
    </md-content>
    
    <!-- DEV USE -->
    <br><br>
    <p class="center" v-if="showNumbers">{{ numbers }}</p>

    <!-- ALERTS -->
    <md-dialog-alert
      :md-active.sync="alerts.city"
      md-title="Invalid or missing input."
      md-content="Please select a city to send from."
      md-confirm-text="Ok" />

    <md-dialog-alert
      :md-active.sync="alerts.numbers"
      md-title="Invalid or missing input."
      md-content="Please include at least one phone number to send to."
      md-confirm-text="Ok" />

    <md-dialog-alert
      :md-active.sync="alerts.checkNumbers"
      md-title="Invalid or missing input."
      md-content="One or more of the submitted phone numbers are formatted incorrectly."
      md-confirm-text="Ok" />

    <md-dialog-alert
      :md-active.sync="alerts.message"
      md-title="Invalid or missing input."
      md-content="Please include a message to send."
      md-confirm-text="Ok" />

    <md-dialog-alert
      :md-active.sync="alerts.pin"
      md-title="Incorrect PIN."
      md-content="The PIN number you input is incorrect."
      md-confirm-text="Ok" />

    <!-- PROMPTS -->
    <md-dialog-prompt
      :md-active.sync="prompts.pin"
      v-model="pin.input"
      md-title="Please input the PIN number"
      md-input-maxlength="8"
      md-input-placeholder="PIN"
      md-confirm-text="Done" 
      @md-confirm="correctPin" />

    <md-dialog-confirm
      :md-active.sync="prompts.sendMessage"
      md-title="Are you sure you want to send this message?"
      :md-content="confirmSendContent"
      md-confirm-text="Yes" 
      @md-confirm="sendMessage"/>

    <!-- SNACKBAR -->
    <md-snackbar md-position="center" :md-active.sync="server.showSnackbar" md-persistent>
      <span v-if="server.failedNumbers.length == 0">Message successfully sent to all phone numbers!</span>
      <span v-else>Some messages may have failed to send.</span>
      <!-- <md-button class="md-primary" @click="showSnackbar = false">Retry</md-button> -->
    </md-snackbar>
  </div>
</template>

<script>
import  Health  from './Health.vue'

export default {
  // name: 'app',
  components: { Health },
  data: () => ({
    textMessage: '',
    prewrittenMessage: {
      chosenMessage: '',
      custom: '',
      atxInv: 'You’re invited to participate in a MediaScience Study that pays between $60 - $180! CALL IN to check your eligibility! 512-837-5646',
      atxRem: 'You’re scheduled to participate in a MediaScience study TODAY! Please arrive 10 min prior to your appointment. There is no grace period for late arrivals. CALL IN if you need to cancel your appointment. 512-837-5646',
      chiInv: 'You’re invited to participate in a MediaScience Study that pays between $60 - $180! CALL IN to check your eligibility! 312-372-6300',
      chiRem: 'You’re scheduled to participate in a MediaScience study TODAY! Please arrive 10 min prior to your appointment. There is no grace period for late arrivals. CALL IN if you need to cancel your appointment. 312-372-6300'
    },
    test: true,
    
    city: null,
    number: null,

    alerts: {
      city: false,
      numbers: false,
      checkNumbers: false,
      message: false,
      pin: false
    },
    prompts: {
      sendMessage: false,
      pin: false
    },
    server: {
      sendingMessages: false,
      serverResponses: 0,
      failedNumbers: [],
      showSnackbar: false
    },
    pin: {
      input: null
    },
    phoenix: false,

    showNumbers: false, // DEV USE
  }),
  computed: {
    //
    //  Organizes user inputed numbers from 'number' into an array, separated by new lines
    //
    numbers () {
      if (this.number != null && this.number.length > 0) {
        return this.number.split('\n')
      } else {
        return []
      }
    },

    //
    //  Returns a list of numbers that have duplicates
    //
    duplicateNumbers () {
      let counts = {}
      let result = []
      
      this.numbers.forEach((number) => {
        if (!counts[number]) {
          counts[number] = 1
        } else {
          counts[number] += 1
        }
      })

      this.numbers.forEach((number) => {
        if (counts[number] >= 2) {
          result.push(number)
          counts[number] = 0
        }
      })

      return result
    },

    //
    //  Creates a confirm message based off of user input
    //
    confirmSendContent () {
      let message = ''
      
      if (this.duplicateNumbers.length > 0) {
        if (this.duplicateNumbers.length > 1) {
          message += 'There are duplicates of the following number(s):<br>'
        } else {
          message += 'There are duplicates of the following number:<br>'
        }

        for (let i = 0; i < this.duplicateNumbers.length; i++) {
          message += this.duplicateNumbers[i] + '<br>'
        }

        message += '<br>'
      }

      if (this.numbers.length > 1) {
        message += 'You are about to send this message to ' + this.numbers.length + ' numbers.'
      } else {
        message += 'You are about to send this message to ' + this.numbers.length + ' number.'
      }

      return message
    },
  },
  methods: {
    //
    //  Checks to see if input is valid, prompts PIN number if content is valid
    //
    validMessage () {
      if (this.city == null) {
        this.alerts.city = true
        return
      }

      if (this.numbers.length == 0) {
        this.alerts.numbers = true
        return
      }

      if (!this.checkNumbers()) {
        this.alerts.checkNumbers = true
        return
      }

      if (this.textMessage.length == 0) {
        this.alerts.message = true
        return
      }

      this.prompts.pin = true
    },

    //
    //  Used by validMessage(), checks to see if inputed numbers match Twilio's format
    //
    checkNumbers () {
      for (let i = 0; i < this.numbers.length; i++) {
        let number = this.numbers[i]
        if (!(
          /^[2-9]\d{2}-\d{3}-\d{4}$/.test(number) ||    // 123-456-7890
          /^\d{10}$/.test(number)                       // 1234567890
        )) {
          return false
        }
      }
      return true
    },

    //
    //  Checks to see if PIN inputed by user is correct, if so, prompt send message confirmation
    //
    correctPin () {
      this.$http.get('https://twilio-phx.mediasciencelabs.com/api/pin').then((response) => {
        if (response.body.data == this.pin.input) {
          this.prompts.sendMessage = true
        } else {
          this.alerts.pin = true
        }
      })
    },

    setMessage () {
      this.textMessage = this.prewrittenMessage.chosenMessage
      // this.textMessage = 'test test test!!'
    },

    //
    //  Handles the logic of sending message to Phoenix which sends message to Twilio API
    //
    sendMessage () {
      this.server.sendingMessages = true
      this.server.serverResponses = 0

      // We need to send API request for every number we have
      for (let i = 0; i < this.numbers.length; i++) {
        this.$http.post('https://twilio-phx.mediasciencelabs.com/api/message', {
          to: this.numbers[i],
          from: this.city,
          body: this.textMessage
        })
        .then(response => {
          this.server.serverResponses++

          if (response.body.data != 1) {
            console.log("Failed to send text message to " + response.body.data + ": " + response.body.reason)
            this.server.failedNumbers.append(response.body.reason)
          } else {
            console.log("Successful response from " + this.numbers[i])
          }

          // Check if we've receieved every response
          if (this.server.serverResponses == this.numbers.length) {
            this.server.sendingMessages = false
            this.server.showSnackbar = true
          }
        })
      }
    }
  }
}
</script>

<style>
.md-content {
  width: 500px;
  margin: auto;
  align-items: center;
  text-align: center;
}
.center {
  width: 500px;
  margin: auto;
  align-items: center;
  text-align: center;
}
</style>
